<template>
  <div class="layerParentContainer">
    <div :class="this.overlayEnabled ? 'overlay' : ''"></div>
    <!-- ---------------------------------back button--------------------------------->
    <div class="backBtnContainer"  id="backButton" v-if="this.backEnabled" @click="backFunction">
       <el-button plain class="backBtn"><b-icon icon="chevron-left"></b-icon></el-button>
    </div>

    <!-- ---------------------------------undo redo button---------------------------->
    <div class="undoRedoContainerOuter" v-if="this.undoRedoVisible">
      <div class="undoRedoContainer">
        <el-button id="studio-app-undo-button" :disabled="!undoEnabled" :class="['navBarIcon', !undoEnabled ? 'iconNavBar-undo-disabled' : 'iconNavBar-undo']" circle
          @click="undoFunction" ><b-icon icon="arrow-counterclockwise"></b-icon> </el-button>
          <el-button id="studio-app-undo-button" :disabled="!redoEnabled" :class="['navBarIcon', !redoEnabled ? 'iconNavBar-undo-disabled' : 'iconNavBar-undo']" circle
          @click="redoFunction" ><b-icon icon="arrow-clockwise"></b-icon>  </el-button>
          <el-button type="text"  class="resetIcon"  @click="deleteFunction"> <b-icon icon="trash"></b-icon></el-button>
      </div>
      <div class="" v-show="this.actionButtonEnabled&&actionButtonText&&!isMobileView">
      <el-button 
        type="primary"
        class="commonBtnDV" 
        id=""
        :disabled="!isCommonBtnVisible"
        @click="mainActionDependingOnState"
        >
        {{actionButtonText}}
        </el-button
      >
    </div>
    </div>

    <!-- ---------------------------------2D 3D button-------------------------------->
    <div :class="['Container2d3d',isTooltipShow&&'showOnOverlayMD']" v-if="this.viewChangeEnabled&&isMobileView">
      <div class="tooltipContainer3DBtn tooltip2DMobile" v-if="isTooltipShow" >
          <p class="tooltipText3d">
            Switch between 2D and 3D view here.
          </p>
          <div id="tooltipClose" @click="close2d3dTooltip" class="tooltipBtnCont">
            <p class="nextBtn" >
              Skip
            </p>          </div>
        </div>
      <div id="2dButton" :class="['Cont2d', btn2d == true ? 'cont2d3dActive' : '']" @click="switch2d">
        <p class="text2d">2D</p>
      </div>
      <div class="positionR">
        <div id="3dButton" :class="['Cont3d', btn3d == true ? 'cont2d3dActive' : '']" @click="switch3d">
          <p class="text3d">3D</p>
        </div>
       
      </div>
    </div>

    <!-- Solar Access and Irradiance Map -->
   
    <div class="ContainerSolaAccess" v-if="this.viewChangeEnabled&&isMobileView">
      <div :class="['tooltipContainerSolarAccessBtn',isSolarAccessTooltip?'change-bottom-solarAccess':'change-bottom-irradiance' ]" v-if="isSolarAccessTooltip||isIrradianceMapTooltip" >
          <p class="tooltipText3d">
            {{isSolarAccessTooltip?'View solar access of your modules ':'View irradiations on your roof'}}
          </p>
          <div id="solarIrradiance" @click="close2d3dTooltip" class="tooltipBtnCont">
            <p class="nextBtn" >
              Skip
            </p>          </div>
        </div>
      <div style="display: grid;row-gap: 16px;">
        <div id="solarAccess" :class="['icon-container',isSolarAccessTooltip&&'showOnOverlay']" @click="switchSolarAccess">
          <div :class="[solarAccess == true ? 'selectedSolarAccess' : '']">
            <img v-if="solarAccess" src="../../assets/solaraccesswhite.svg" alt="">
            <img v-else src="../../assets/solaraccess.svg" alt="">
          </div>
      </div>
      <div id="irradianceMap" :class="['icon-container',isIrradianceMapTooltip&&'showOnOverlay']" @click="switchIrradianceMap">
        <div :class="[irradianceMap == true ? 'selectedSolarAccess' : '']">
          <img v-if="irradianceMap" src="../../assets/irradiancewhite.svg" alt="">
          <img v-else="irradianceMap" src="../../assets/irradiancemap.svg" alt="">

        </div>
      </div>
      </div>
      </div>

      <!-- 2d 3d and other btns Desktop -->
       <div class="Container2d3dDV" v-if="this.viewChangeEnabled&&!isMobileView">
      <div class="ContainerSolarIrradiance">
        <div :class="['tooltipContainerSolarAccessBtn', 'bottomPosition' ,isSolarAccessTooltip?'solarAccessRight':'irradianceRight' ]" v-if="isSolarAccessTooltip||isIrradianceMapTooltip" >
          <p class="tooltipText3d">
            {{isSolarAccessTooltip?'View solar access of your modules ':'View irradiations on your roof'}}
          </p>
          <div id="solarIrradiance" @click="close2d3dTooltip" class="tooltipBtnCont">
            <p class="nextBtn" >
              Skip
            </p>          </div>
        </div>
        <div id="solarAccess" :class="['icon-container',isSolarAccessTooltip&&'showOnOverlay']" @click="switchSolarAccess">
          <div :class="[solarAccess == true ? 'selectedSolarAccess' : '']">
            <img v-if="solarAccess" src="../../assets/solaraccesswhite.svg" alt="">
            <img v-else src="../../assets/solaraccess.svg" alt="">
          </div>
      </div>
      <div id="irradianceMap" :class="['icon-container',isIrradianceMapTooltip&&'showOnOverlay']" @click="switchIrradianceMap">
        <div :class="[irradianceMap == true ? 'selectedSolarAccess' : '']">
          <img v-if="irradianceMap" src="../../assets/irradiancewhite.svg" alt="">
          <img v-else="irradianceMap" src="../../assets/irradiancemap.svg" alt="">

        </div>
      </div>
      </div>

        <div :class="['container2d3dbtns',isTooltipShow&&'showOnOverlay']" >
          <div class="tooltipContainer3DBtn tooltip2DDesktop" v-if="isTooltipShow" >
          <p class="tooltipText3d">
            Switch between 2D and 3D view here.
          </p>
          <div id="tooltipClose" @click="close2d3dTooltip" class="tooltipBtnCont">
            <p class="nextBtn" >
              Skip
            </p>          </div>
        </div>
      <div id="2dButton" :class="['Cont2d', btn2d == true ? 'cont2d3dActive' : '']" @click="switch2d">
        <p class="text2d">2D</p>
      </div>
      <div class="positionR">
        <div id="3dButton" :class="['Cont3d', btn3d == true ? 'cont2d3dActive' : '']" @click="switch3d">
          <p class="text3d">3D</p>
        </div>
       
      </div>
    </div>
    <div class="" v-show="this.actionButtonEnabled&&actionButtonText&&!isMobileView">
      <el-button 
        type="primary"
        class="commonBtnDV" 
        id=""
        :disabled="!isCommonBtnVisible"
        @click="mainActionDependingOnState"
        >
        {{actionButtonText}}
        </el-button>
    </div>
       </div>


    <!-- ---------------------------------sidebar------------------------------------->
    <Sidebar v-if="this.sidebarEnabled" />

    <!-- ---------------------------------zoom slider--------------------------------->
    <div :class="['sliderContainer',isMobileView?'sliderTopPositionMV':'sliderTopPositionDV']" v-show="this.zoomSliderEnabled&&!this.isObstructionHeightOpen">
      <div class="slider-demo-block" >
        <el-slider id="obstrSlider" v-model="this.studioStore.zoomValue" :min="1" :max="10" :show-tooltip="true" vertical height="240px" placement="right" @input="sliderChanged"/>
        <div class="sliderTooltipTwo" v-if="isNextSliderTooltipShow">
          <p class="tooltipText3d">
            Please use this slider to increase or decrease the size of the object.
          </p>
          <div class="tooltipBtnCont">
            <p class="nextBtn" @click="isNextSliderTooltipShow = false">
              Done
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------------------------------rotation-bar slider------------------------->
    <div class="rotSliderContainer" v-show="this.rotationSliderEnabled&&!this.isObstructionHeightOpen ">
      <div class="main">
        <div class="slider-container">
    <el-slider
      v-model="this.studioStore.rotationValue"
      id="obstrRotationSlider"
      :min="0"
      :max="180"
      :step="15"
      :show-tooltip="false"
      class="custom-slider"
      @input="sliderRotated"
    />
    <div class="sliderTooltip" v-if="isFirstSliderTooltipShow">
              <p class="tooltipText3d">
                Please use this slider to rotate and align the rectangle to the object present on your rooftop.
              </p>
              <div class="tooltipBtnCont">
                <p class="nextBtn" @click="nextSliderTooltipShow()">
                  Next
                </p>
              </div>
            </div>
    <div
      class="custom-thumb"
      :style="{ left: `${(parseInt(this.studioStore.rotationValue)/180)*100 + '%'}` }"
    >
      {{ this.studioStore.rotationValue }}°
    </div>
  </div>
      </div>
    </div>

    <!-- ---------------------------------No of building input button----------------->
    <div class="containerMD" v-if="this.floorInputEnabled">
      <InfoCollectionForm v-if="isMobileView" :isFooter="true" @updateBtnStatus="checkFormBtn"/>
      <el-dialog
            v-model="dialogVisible"
            title=" "
            width="390px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-else
          >
          <InfoCollectionForm  :isFooter="false" @updateBtnStatus="checkFormBtn"/>

            <template #footer>
              <div class="dialog-footer">
                <el-button @click="backFunction" class="btn-content"
                  >Close</el-button
                >
                <el-button
                  type="primary"
                  class="btn-content btn-color"
                  :disabled="!formBtnDisabled"
                  @click="setInfoFormDataToStore"
                >
                  Draw Roof
                </el-button>
              </div>
            </template>
          </el-dialog>
      </div>
    <!-- ---------------------------------Calculate savings--------------------------->
    <CalculateSavings v-if="savingsEnabled&&isMobileView" />
    <el-dialog
            v-model="savingsEnabled"
            title=" "
            width="390px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-else
          >
          <CalculateSavings v-if="savingsEnabled" />
          </el-dialog>


    <!-- ---------------------------------gif button---------------------------------->
    <div :class="['gifContainer', this.actionButtonEnabled ? 'topGifContainer' : '']" v-if="this.gifEnabled">
      <div class="positionR">
        <div class="bulbCont">
          <img :src="
            gifBtnToggle == true ? allIcon.get('cross') : allIcon.get('bulb')
          " class="bulbIcon" @click="gifBtnToggle = !gifBtnToggle" />
        </div>
        <div class="tooltipContainer" v-if="gifBtnToggle == true">
          <h4 class="tooltipHeading">{{ gifContent.heading }}</h4>
          <p class="tooltipText">
            {{ gifContent.text }}
          </p>
          <img :src="allIcon.get('Draw-roof')" class="gifImg" />
        </div>
      </div>
    </div>

    <!-- ---------------------------------common button------------------------------->
    <div class="bottomBtnContainer" v-show="this.actionButtonEnabled&&actionButtonText&&isMobileView">
      <el-button 
        type="primary"
        class="commonBtn" 
        id="mainButton"
        :disabled="!isCommonBtnVisible"
        @click="mainActionDependingOnState"
        >{{actionButtonText}}</el-button
      >
    </div>

    <!-- Obstruction Height -->
    <div class="containerMD" v-if="this.isObstructionHeightOpen&&isMobileView">
      <div class="info-container">
      <div class="info-content smLabel">
        <p class="inputLabel">Height Of Obstruction</p>
                <el-input
                :placeholder="'Enter Height'"
                v-model="obstructionHeight"
                type="number"
                :controls="false"
                @input="
                  handleInputValueChange(
                    obstructionHeight,
                    'obstruction_height')"
                class="no-arrow-buttons"
                @keydown="preventSpecialCharacters"
              >
              <template #append>
                  <div>
                    <span>Meters</span>
                  </div>
                </template>
              </el-input>
        <div
        v-if="disableObstructionHeight"
        class="warning"
      >
      Should be between 0.05 and 50.
      </div>
      </div>
      </div>
      <el-button 
        type="primary" 
        class="drwBtnBtnMD" 
        :disabled="disableObstructionHeight||!obstructionHeight" 
        @click="obstructionHeightEntered">
      Place Obstruction</el-button>
    </div>
    <el-dialog
            v-model="obstructionHeightVisible"
            title=" "
            width="272px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            align-center
            v-else
          >
    <div class="containerDV" v-if="this.isObstructionHeightOpen&&!isMobileView">
      <div class="info-container">
      <div class="info-content smLabel">
        <p class="inputLabel">Height Of Obstruction</p>
                <el-input
                :placeholder="'Enter Height'"
                v-model="obstructionHeight"
                type="number"
                :controls="false"
                @input="
                  handleInputValueChange(
                    obstructionHeight,
                    'obstruction_height')"
                class="no-arrow-buttons"
                @keydown="preventSpecialCharacters"
              >
              <template #append>
                  <div>
                    <span>Meters</span>
                  </div>
                </template>
              </el-input>
        <div
        v-if="disableObstructionHeight"
        class="warning"
      >
      Should be between 0.05 and 50.
      </div>
      </div>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">

        <el-button 
          type="primary" 
          class="drwBtnBtnDV" 
          style="border:none"
          :disabled="disableObstructionHeight||!obstructionHeight" 
          @click="obstructionHeightEntered">
        Place Obstruction</el-button>
      </div>
    </div>
    </el-dialog>


  </div>
</template>

<script>
import utils from '@/pages/siteSurvey/utils';
import Sidebar from "./sidebar.vue";
import CalculateSavings from "./calculateSavings.vue";
import { useStudioStore } from "../store/studioStore";
import {
  FLOOR_STATE,
  DRAWING_STATE,
  OBSTRUCTION_STATE,
  PANEL_VIEW_STATE,
  SAVINGS_STATE,
  REPORT_STATE,
  defaultComponentsData,
  DRAW_OBSTRUCTION,
} from "./constants";
import Obstruction from '../../core/Objects/Obstruction';
import { mapState,mapActions } from 'pinia';
import InfoCollectionForm from './InfoCollectionForm.vue';
import { useScreenSize } from '../../utils';
// import { solarCalculatorStore } from '../../pages/store/solarCalculator';

export default {
  components: {
    Sidebar,
    CalculateSavings,
    InfoCollectionForm,
  },

  data() {
    return {
      gifBtnToggle: false,
      btn2d: false,
      btn3d: true,
      isTooltipShow: true,
      studioStore: useStudioStore(),
      zoomValue: 3,
      rotationValue: 0,
      floorValue: null,
      actionButtonText: "Done",
      zoomMin: 1,
      zoomMax: 10,
      gifContentForDrawing: {
        heading: "How to Draw a Roof",
        text: "Click on each corner of the roof you want draw.",
        gifSrc: "",
      },
      gifContentForObstruction: {
        heading: "Add Objects",
        text: "Select object from the menu and drag to place.",
        gifSrc: "",
      },
      gifContent: "",
      allIcon: utils.images,
      value1: 0,
      isFirstSliderTooltipShow: true,
      isNextSliderTooltipShow: false,
      infoFormData:{
        floorValue: null,
        supply_phase: 'Single Phase',
        tariff_rate: 7,
        monthly_bill: null,
        sanction_load: null,
      },
      inputTariffValue: 7,
      errorData:{
        monthly_bill:false,
        sanction_load:false,
        floorValue:false,
      },
      disableRadio:{
        isThreeDisabled:false,
        isSingleDisabled:false
      },
      obstructionHeight:null,
      disableObstructionHeight:false,
      solarAccess: false,
      irradianceMap:false,
      isSolarAccessTooltip: false,
      isIrradianceMapTooltip: false,
      formBtnDisabled:true,
      screenSize: useScreenSize(),
      value_rotate:90,
    };
  },

  computed: {
    // ...mapState(solarCalculatorStore, {
    //   calculatorData: (state) => state.CALCULATOR_DATA_STATE,
    // }),
    ...mapState(useStudioStore, {
       isObstructionHeightOpen: (state) => state.openObstructionHeight,
       obstructionType:(state) => state.obstructionType,
       gifBtnToggleStore: (state) => state.gifBtnToggle,
    }),
    currentAppState() {
      return this.studioStore.currentAppState;
    },
    currentObstructionType() {
      return this.studioStore.obstructionType;
    },
    //Visibility Functions
    overlayEnabled() {
      if (this.currentAppState === FLOOR_STATE) return false;
      if (this.currentAppState === DRAWING_STATE) {
        if (this.gifBtnToggle === true) return true;
        return false;
      }
      if (this.currentAppState === OBSTRUCTION_STATE){
        if (this.gifBtnToggle === true) return true;
        if (this.isFirstSliderTooltipShow === true) return true;
        if (this.isNextSliderTooltipShow === true) return true;
        return false;
      }
      if (this.currentAppState === PANEL_VIEW_STATE) {
        if (this.isTooltipShow||this.isSolarAccessTooltip||this.isIrradianceMapTooltip) return true;
        return false;
      }
      if(this.currentAppState === SAVINGS_STATE) return true;
      if(this.currentAppState === REPORT_STATE) return false;
      return false;
    },
    backEnabled() {
      if(this.currentAppState === FLOOR_STATE) return true;
      if(this.currentAppState === DRAWING_STATE) return true;
      if(this.currentAppState === OBSTRUCTION_STATE) return true;
      if(this.currentAppState === PANEL_VIEW_STATE) return true;
      if(this.currentAppState === SAVINGS_STATE) return true;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    undoRedoVisible() {
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return true;
      if(this.currentAppState === OBSTRUCTION_STATE) return true;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    viewChangeEnabled() {
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return true;
      if(this.currentAppState === SAVINGS_STATE) return true;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    zoomSliderEnabled() {
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE  && this.$stageInstance.currentSelectedObject instanceof Obstruction) return true;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    rotationSliderEnabled() {
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE  && this.$stageInstance.currentSelectedObject instanceof Obstruction) return true;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    sidebarEnabled() {
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE){ 
        return this.isObstructionHeightOpen||(this.obstructionType==='drawObstruction')? false: true;
      };
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    floorInputEnabled() {
      if(this.currentAppState === FLOOR_STATE) return true;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    savingsEnabled() {
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return true;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    gifEnabled() {
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return true;
      if(this.currentAppState === OBSTRUCTION_STATE) return true;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    actionButtonEnabled() {
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return true;
      if(this.currentAppState === OBSTRUCTION_STATE) {
        return this.isObstructionHeightOpen? false: true;
      };
      if(this.currentAppState === PANEL_VIEW_STATE) return true;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    undoEnabled() {
      return this.studioStore.undoEnabled;
    },
    redoEnabled(){
      return this.studioStore?.redoEnabled||false;
    },
    isCommonBtnVisible() {
      if(this.currentAppState === DRAWING_STATE) {
        if(this.studioStore.basePolygonDrawn){
          this.actionButtonText = "Next";
          return true;
        }
        if(this.studioStore.atleast3PointsDrawn){
         
          this.actionButtonText = "Complete";
          return true;
        }
        else {
          this.actionButtonText = "";
          return false;
        }
      }
      if(this.currentAppState === OBSTRUCTION_STATE) {
        this.actionButtonEnabled=false;
       if(this.obstructionType==="drawObstruction"){
          if(this.studioStore.atleast3PointsDrawn){
            this.actionButtonText = "Complete";    
            return true;
          }else{
            this.actionButtonText = "";
            return false;
          }
        }else   if(!this.studioStore.obstructionPlacedInScene){
          this.actionButtonText = "Continue Without Object";
        }
        else{
          this.actionButtonText = "Done";
        }
        return true;
      }
      if(this.currentAppState === PANEL_VIEW_STATE) {
        this.actionButtonText = "Generate Result";
        return true;
      }
      return false;
    },
    checkDrawRoofDisabled() {
      const errorData={};
// Check if all values are provided
for (const key in this.infoFormData) {
  if (this.infoFormData[key] === null || this.infoFormData[key] === '' || this.infoFormData[key] === undefined) {
    errorData[key]=true;
  }else{
    errorData[key]=false;
  }
}
if(Object.values(errorData).every(value => value === false)){
  // Validate specific fields with range constraints
  if(this.infoFormData.floorValue && parseInt(this.infoFormData.floorValue) && this.infoFormData.floorValue<0 && this.infoFormData.floorValue>50) {
    errorData.floorValue = true;
        }else{
          errorData.floorValue = false;
        }
  if (this.infoFormData.sanction_load !== null && (parseInt(this.infoFormData.sanction_load)<1 || parseInt(this.infoFormData.sanction_load )>100)) {
    errorData.sanction_load = true;
  }else{
   errorData.sanction_load = false;
}
 if(this.infoFormData.monthly_bill !== null && (parseInt(this.infoFormData.monthly_bill)<1 || parseInt(this.infoFormData.monthly_bill )>9999999)){
  errorData.monthly_bill = true;
 }else{
  errorData.monthly_bill = false;
 }
}
const anyTrue = Object.values(errorData).every(value => value === false);
return anyTrue; // Validation passed
    },
    isMobileView(){
     return this.screenSize.isMobile ;
    },
    dialogVisible(){
      return this.floorInputEnabled && !this.screenSize.isMobile;
    },
    obstructionHeightVisible(){
      return this.isObstructionHeightOpen && !this.screenSize.isMobile;
    }
  },

  async mounted() {
    const appState = localStorage.getItem('currentAppState');
    let componentData = localStorage.getItem('componentData');
    if (componentData) {
      componentData = JSON.parse(componentData);
      this.infoFormData=componentData?.infoData||this.infoFormData;
      this.$stageInstance.floorValue = this.infoFormData?.floorValue||null;
      if(this.infoFormData?.sanction_load){
        if(this.infoFormData?.sanction_load<=3){
          this.disableRadio.isSingleDisabled=false;
          this.disableRadio.isThreeDisabled=true;
        }else if(this.infoFormData?.sanction_load>5){
          this.disableRadio.isSingleDisabled=true;
          this.disableRadio.isThreeDisabled=false;
        }else{
          this.disableRadio.isSingleDisabled=false;
          this.disableRadio.isThreeDisabled=false;
        }
      }
    }
    this.studioStore.$patch({
      currentAppState: appState === null ? FLOOR_STATE : appState,
    });
    if(this.currentAppState === DRAWING_STATE){
      this.gifContent = this.gifContentForDrawing;
      if(!(this.$stageInstance.polygonModel)){
        this.$stageInstance.newPolygonModel(this.infoFormData.floorValue);
      }
    }
    if (this.currentAppState === OBSTRUCTION_STATE) {
      this.gifContent = this.gifContentForObstruction;
      this.$stageInstance.dragControls.activate();
      this.isFirstSliderTooltipShow = false;
      setTimeout(() => {
        this.sliderBarRotation();
      }, 50)
      return true;
    }
    if(this.currentAppState===PANEL_VIEW_STATE) {
      this.isTooltipShow = false;
      const vm = this;
      setTimeout(() => {
        vm.addTouchEvents();
      }, 100);
      this.$stageInstance.placePanels().then(() => {
        this.$stageInstance.deselectOtherSelectedMeshes(this.$stageInstance.ground);
        this.switch3d();
        this.$stageInstance.fetchIrradianceAndAccess();
      })

    }
    if(this.currentAppState === SAVINGS_STATE) this.isTooltipShow = false;
  },
  created(){
    this.screenSize.setupListener();
  },
  beforeDestroy() {
    this.screenSize.removeListener();
  },

  methods: {
    ...mapActions(useStudioStore, {
      setIsObstructionHeightOpen: "OPEN_OBSTRUCTION_HEIGHT",
      setObstructionHeight:"SET_OBSTRUCTION_HEIGHT",
      setInfoFormDataToStore: "SET_INFORMATION_FORM_DATA_STORE",
      setObstructionType:"SET_OBSTRUCTION_TYPE",
    }),
    // ...mapActions(solarCalculatorStore, {
    //   UPDATE_CALCULATOR_DATA: "UPDATE_CALCULATOR_DATA",
    // }),
    nextSliderTooltipShow(){
      this.isFirstSliderTooltipShow = false;
      this.isNextSliderTooltipShow = true;
    },

    sliderBarRotation() {
      let slider = document.getElementById('slider')
      let selector = document.getElementById('selector')
      let selectValue = document.getElementById('selectValue')
      let progressBar = document.getElementById('progressBar')
      selectValue.innerHTML = slider.value+'&#xb0';
      slider.oninput = function() {
        selectValue.innerHTML = this.value+'&#xb0'
        selector.style.left = (parseInt(this.value)/180)*100 + '%'
        progressBar.style.width = (parseInt(this.value)/180)*100 + '%'
      }
    },
    //Action functions
    floorsEntered() {
      this.studioStore.$patch({
        currentAppState: DRAWING_STATE,
      });
      if (this.currentAppState === DRAWING_STATE) {
        if(!this.studioStore.basePolygonDrawn){
          this.$stageInstance.newPolygonModel(this.infoFormData.floorValue);
        }
        else {
          this.$stageInstance.polygonModel.updateHeightOnFloorChange(this.infoFormData.floorValue);
          this.$stageInstance.floorValue = this.infoFormData.floorValue;
        }
      }
      this.setFloorValueInLocalStorage(this.infoFormData);
      this.setAppStateInLocalStorage(DRAWING_STATE);
      this.gifContent = this.gifContentForDrawing;
      this.gifBtnToggle = true;
    },
    backFunction() {
      if (this.currentAppState === FLOOR_STATE) {
        this.$router.push({name : 'mapForDesignTool'})
      }
      if (this.currentAppState === DRAWING_STATE) {
        if (this.$stageInstance.drawManager.enabled) {
          this.$stageInstance.drawManager.resetDrawManager();
          this.$stageInstance.drawManager.onCancel();
        } 
        this.studioStore.$patch({
          currentAppState: FLOOR_STATE,
        });
        this.setAppStateInLocalStorage(FLOOR_STATE);
      }
      if (this.currentAppState === OBSTRUCTION_STATE) {
        this.$stageInstance.dragControls.enablePolygon();
        this.studioStore.$patch({
          currentAppState: DRAWING_STATE,
        });
        this.gifContent = this.gifContentForDrawing;
        this.setAppStateInLocalStorage(DRAWING_STATE);
      }
      if (this.currentAppState === PANEL_VIEW_STATE) {
        this.switch2d();
        this.$stageInstance.controlsManager.reset();
        this.$stageInstance.removePanels();
        this.$stageInstance.dragControls.activate();
        this.studioStore.$patch({
          currentAppState: OBSTRUCTION_STATE,
        });
        this.gifContent = this.gifContentForObstruction;
        this.setAppStateInLocalStorage(OBSTRUCTION_STATE);
        setTimeout(() => {
        this.sliderBarRotation();
        }, 50)
      }
      if (this.currentAppState === SAVINGS_STATE) {
        this.studioStore.$patch({
          currentAppState: PANEL_VIEW_STATE,
        });
        this.setAppStateInLocalStorage(PANEL_VIEW_STATE);
      }
    },
    async mainActionDependingOnState() {
      if (this.currentAppState === FLOOR_STATE) {
        // this.studioStore.$patch({undoEnabled: false});
        return this.nullFunc;
      }
      if (this.currentAppState === DRAWING_STATE) {
        if (this.studioStore.basePolygonDrawn) {
          this.studioStore.$patch({
            currentAppState: OBSTRUCTION_STATE,
          });
          this.$stageInstance.dragControls.disablePolygon();
          this.setAppStateInLocalStorage(OBSTRUCTION_STATE);
          this.gifContent = this.gifContentForObstruction;
          this.gifBtnToggle = true;
          this.studioStore.$patch({undoEnabled: true});
        }
        else if (this.studioStore.atleast3PointsDrawn) {
          if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.onComplete();
            this.studioStore.$patch({basePolygonDrawn: true});
            this.studioStore.$patch({undoEnabled: false});
          }
        }
        return this.nullFunc;
      }
      if (this.currentAppState === OBSTRUCTION_STATE) {
        if (this.studioStore.atleast3PointsDrawn&&this.obstructionType==="drawObstruction") {
          if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.onComplete();
            this.studioStore.$patch({basePolygonDrawn: false});
            this.studioStore.$patch({undoEnabled: false});
            this.setObstructionType(null);
            this.studioStore.$patch({obstructionPlacedInScene:true});
          }
        }else{
          this.$stageInstance.placePanels().then(() => {
            this.studioStore.$patch({
              currentAppState: PANEL_VIEW_STATE,
            });
            this.$stageInstance.deselectOtherSelectedMeshes(this.$stageInstance.ground);
            this.$stageInstance.dragControls.deactivate();
            this.setAppStateInLocalStorage(PANEL_VIEW_STATE);
            const vm = this;
            setTimeout(() => {
              vm.addTouchEvents();
            }, 100);
            this.$stageInstance.initialize2D_3DControls();
            this.switch3d();
            if (this.isMobileView) {
              this.isTooltipShow = true;
            } else {
              this.isSolarAccessTooltip = true;
            }

            // Call the API to store heatMap and SolarAccess.
            this.$stageInstance.fetchIrradianceAndAccess();
            return this.nullFunc;
          }, (error) => {
            // TODO: Write code for error notification panel
            this.$message({
              showClose: true,
              message: error.message,
              type: "error",
              center: true,
            });
            console.error(error);
          });
        }
      }
      if (this.currentAppState === PANEL_VIEW_STATE) {
         this.$router.push('/solarCalculator');
          this.switch3d();
          // RESET FUNCTION REQUIRES DELAY
          this.$stageInstance.controlsManager.reset();
          this.$stageInstance.controlsManager._2dControls.disable();
          this.$stageInstance.controlsManager._3dControls.disable();
          // TRY CALLING WITH DELAY WOULD WORK BT STETIMEOUT
          setTimeout(() => {
            this.$stageInstance.saveCanvasImage();
          }, 100);
          this.studioStore.$patch({
            currentAppState: SAVINGS_STATE,
          });
          this.setAppStateInLocalStorage(SAVINGS_STATE);
          return this.nullFunc;
      }
      return null;
    },
    //LOCAL STORAGE MANAGEMENT FUNCIONS
    setAppStateInLocalStorage(appState = FLOOR_STATE) {
      localStorage.setItem('currentAppState', appState);
    },
    setFloorValueInLocalStorage(infoData = 0) {
      let componentJSON = localStorage.getItem('componentData') ? JSON.parse(localStorage.getItem('componentData')) : defaultComponentsData();
      componentJSON.floorValue = infoData?.floorValue||0;
      componentJSON.infoData=infoData;
      localStorage.setItem('componentData', JSON.stringify(componentJSON));
      if(localStorage.getItem('stageData')){
          let savedStageData = JSON.parse(localStorage.getItem('stageData'));
          savedStageData.floorValue = infoData?.floorValue||0;
          localStorage.setItem('stageData', JSON.stringify(savedStageData));
      }
    },
    //Random funcs
    undoFunction() {
      if (this.currentAppState === DRAWING_STATE) {
        if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.removePoint();
        }else{
          // position undo here
        }
      }
      if (this.currentAppState === OBSTRUCTION_STATE) {
        // this.$stageInstance.removeFromObjectsArray();
        this.$stageInstance.handleUndo();
      }
      return this.nullFunc();
    },

       //Random funcs
       redoFunction() {
      if (this.currentAppState === DRAWING_STATE) {
        if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.addPoint();
        }else{
          // position undo here
        }
      }
      if (this.currentAppState === OBSTRUCTION_STATE) {
        // this.$stageInstance.removeFromObjectsArray();
        this.$stageInstance.handleUndo();
      }
      return this.nullFunc();
    },

    deleteFunction() {
      if (this.currentAppState === DRAWING_STATE) {
        if (this.$stageInstance.polygonModel) {
          if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.resetDrawManager();
          }else{
            this.$stageInstance.polygonModel.removeObject();
            this.$stageInstance.newPolygonModel(this.infoFormData.floorValue);
          }
          this.$stageInstance.studioStore.$patch({basePolygonDrawn:false})
          this.$stageInstance.studioStore.$patch({atleast3PointsDrawn:false})
        }
      }
      else if (this.currentAppState === OBSTRUCTION_STATE) {
        if (this.currentObstructionType === DRAW_OBSTRUCTION) {
          if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.resetDrawManager();
          }
          this.$stageInstance.studioStore.$patch({ obstructionDrawn: false })
          this.$stageInstance.studioStore.$patch({ atleast3PointsDrawn: false })
        }
        this.$stageInstance.removeSelectedObject();
      }

      return this.nullFunc();
    },
    nullFunc() {
      console.log("null function", this.currentAppState);
    },
    addTouchEvents(){
      let obj = document.getElementById('3dButton');
      obj.addEventListener("touchend", this.switch3d, false);

      obj = document.getElementById('2dButton');
      obj.addEventListener("touchend", this.switch2d, false);

      obj = document.getElementById('backButton');
      obj.addEventListener("touchend", this.removeTouchEvents, false);

      obj = document.getElementById('mainButton');
      obj.addEventListener("touchend", this.removeTouchEvents, false);

      obj = document.getElementById('tooltipClose');
      if(obj){
        obj?.addEventListener("touchend", this.close2d3dTooltip, false); 
      }

      obj = document.getElementById('solarAccess');
      obj.addEventListener("touchend", this.switchSolarAccess, false);

      obj = document.getElementById('irradianceMap');
      obj.addEventListener("touchend", this.switchIrradianceMap, false);
    },
    removeTouchEvents(params){
      let obj = document.getElementById('3dButton');
      obj.removeEventListener("touchend", this.switch3d, false);

      obj = document.getElementById('2dButton');
      obj.removeEventListener("touchend", this.switch2d, false);

      obj = document.getElementById('backButton');
      obj.removeEventListener("touchend", this.removeTouchEvents, false);

      obj = document.getElementById('mainButton');
      obj.removeEventListener("touchend", this.removeTouchEvents, false);

      obj = document.getElementById('solarAccess');
      obj.removeEventListener("touchend", this.switchSolarAccess, false);

      obj = document.getElementById('irradianceMap');
      obj.removeEventListener("touchend", this.switchIrradianceMap, false);
      if(params.currentTarget.id === 'backButton'){
        this.backFunction();
      }
      else if(params.currentTarget.id === 'mainButton'){
        this.mainActionDependingOnState();
      }
      if(this.$stageInstance.controlsManager){
        this.$stageInstance.controlsManager._3dControls.dispose();
        this.$stageInstance.controlsManager._2dControls.dispose();
      }
    },
    switch2d(){
      this.isTooltipShow = false;
      this.btn3d = false;
      this.btn2d = true;
      if(!this.$stageInstance.controlsManager){
        this.$stageInstance.initialize2D_3DControls();
      }
      this.$stageInstance.switchTo2d();
    },
    sliderChanged(){
      this.$stageInstance.obstructionScaled(this.studioStore.zoomValue);
    },
    sliderRotated(){
      this.$stageInstance.obstructionRotated(this.studioStore.rotationValue);
      this.sliderBarRotation();
    },
    switch3d(){
      this.isTooltipShow = false;
      this.btn3d = true;
      this.btn2d = false;
      if(!this.$stageInstance.controlsManager){
        this.$stageInstance.initialize2D_3DControls();
      }
      this.$stageInstance.switchTo3d();
    },
    handleInputValueChange(value,label){
      try{
        if(label === 'floorValue'){
          this.$stageInstance.floorValue = value;
          if(this.infoFormData.floorValue && parseInt(this.infoFormData.floorValue) && (this.infoFormData.floorValue<0 || this.infoFormData.floorValue>50)) {
      this.errorData.floorValue = true;
          }else{
            this.errorData.floorValue = false;
          }
        }
        if(label === 'tariff_rate'){
          this.inputTariffValue = this.infoFormData.tariff_rate;
        }
        if(label === 'supply_phase'){
          this.infoFormData.supply_phase = value;
        }
        if(label === 'monthly_bill'){
          this.infoFormData.monthly_bill = value;
          if(this.infoFormData.monthly_bill !== null && (parseInt(this.infoFormData.monthly_bill)<1 || parseInt(this.infoFormData.monthly_bill )>9999999)){
    this.errorData.monthly_bill = true;
   }else{
    this.errorData.monthly_bill = false;
   }
        }
        if(label === 'sanction_load'){
        if(value)  {if(value<=3){
            this.infoFormData.supply_phase='Single Phase';
            this.disableRadio.isThreeDisabled=true;
            this.disableRadio.isSingleDisabled=false;

          }else if(value>5){
            this.infoFormData.supply_phase='Three Phase';
            this.disableRadio.isSingleDisabled=true;
            this.disableRadio.isThreeDisabled=false;
          }else{
            this.disableRadio.isSingleDisabled=false;
            this.disableRadio.isThreeDisabled=false;
          }}
          if (this.infoFormData.sanction_load !== null && (parseInt(this.infoFormData.sanction_load)<1 || parseInt(this.infoFormData.sanction_load )>100)) {
      this.errorData.sanction_load = true;
    }else{
     this.errorData.sanction_load = false;
  }
      }
      if(label === 'obstruction_height'){
        if(value<0.05||value>50){
          this.disableObstructionHeight=true;
      }else{
        this.disableObstructionHeight=false
        }
      }
      }catch(err){
        console.error('err: ', err);
      }

    },
    handleTariffChange(){
      this.infoFormData.tariff_rate = this.inputTariffValue;
    },
    tariffIncrementDecrement(trigger){
    if(trigger==='increase'){
      this.infoFormData.tariff_rate+=1;
      this.inputTariffValue+=1;
    }  
    if(trigger==='decrease'){
      this.infoFormData.tariff_rate-=1;
      this.inputTariffValue-=1;
    } 
  },
  obstructionHeightEntered(){
    this.setIsObstructionHeightOpen(false);
    this.$stageInstance.initDrawObstructions(this.obstructionType,this.obstructionHeight);
    this.setObstructionHeight(this.obstructionHeight);
  },
  close2d3dTooltip(){
    if(this.isTooltipShow){
      this.isTooltipShow=false;
      if(this.isMobileView){
        this.isSolarAccessTooltip=true;
        setTimeout(() => {
          let obj = document.getElementById('solarIrradiance');
        if(obj){
          obj?.addEventListener("touchend", this.close2d3dTooltip, false); 
        }
          }, 100);
      }
   
    }
   else if(this.isSolarAccessTooltip){
      this.isSolarAccessTooltip=false;
      this.isIrradianceMapTooltip=true;
    }
    else if(this.isIrradianceMapTooltip){
      this.isIrradianceMapTooltip=false;
      if(!this.isMobileView){
        this.isTooltipShow=true;
      }
    }
  },
  async switchSolarAccess(){
    if (this.$stageInstance.heatSolar.apiLoading) {
      this.$message('Loading Solar Access');
    }
    else if (!this.$stageInstance.heatSolar.solarAccess) {
      try {
        await this.$stageInstance.fetchIrradianceAndAccess();
      } catch(error) {
        this.$message({
          showClose: true,
          message: error.message,
          type: "error",
          center: true,
        });
      }
    }
    else {
       if (!this.solarAccess) this.$message({
        showClose: true,
        message: "Solar Access Enabled Successfully",
        type: "success",
        center: true,
      });
      this.solarAccess = !this.solarAccess;
      this.$stageInstance.updateSolarAccess(this.solarAccess);
    }
    // this.irradianceMap=false;
  },
  async switchIrradianceMap(){
    if (this.$stageInstance.heatSolar.apiLoading) {
      this.$message('Loading Irradiance Map');
    }
    else if (!this.$stageInstance.heatSolar.solarAccess) {
      try {
        await this.$stageInstance.fetchIrradianceAndAccess();
      } catch (error) {
        this.$message({
          showClose: true,
          message: error.message,
          type: "error",
          center: true,
        });
      }
    }
    else {
      if (!this.irradianceMap) this.$message({
        showClose: true,
        message: "Irradiance Map Enabled Successfully",
        type: "success",
        center: true,
      });
      this.irradianceMap = !this.irradianceMap;
      this.$stageInstance.updateIrradianceMap(this.irradianceMap);
    }
    // this.solarAccess=false;
  },
  checkFormBtn(status){
    this.formBtnDisabled=status;
  }
  }, 

  watch:{
    gifBtnToggleStore:{
      handler(val){
        this.gifBtnToggle = val;
        this.gifContent=this.gifContentForDrawing;
      }
    },
  }
};
</script>


<style  scoped>
@font-face {
  font-family: "SegoeUI";
  src: url(/fonts/SegoeUI.ttf);
}

  .overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 2;
  }

  .backBtnContainer {
    position: absolute;
    top: 112px;
    left: 12px;
    /* padding: 11px 16px 8px 18px; */
    /* border-radius: 20px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    background-color: #fff; */
    width: 56px;
    height: 40px;
    cursor: pointer;
  }

  .backBtn {
  width:48px;
  height: 48px;
  font-size: 20px;
  background-color: #fff;
  color: #222;
  border:none;
}

  .billError {
    color: rgb(214, 12, 12);
    font-size: 13px;
    margin-top: -10px;
    margin-bottom: 8px;
  }

  .undoRedoContainerOuter{
    position: absolute;
    top: 112px;
    right: 12px;
    display: flex;
    align-items: center;
    gap:16px;
  }

  .undoRedoContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: auto;
    max-width: 136px;
    height: 48px;
    padding: 0px 16px 1px 16px;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    background-color: #fff;
    cursor: pointer;
  }
  
  .layerParentContainer :deep() .el-button.is-circle {
    padding: 0px;
  }

  .iconNavBar-undo:before {
  }
  .iconNavBar-undo, .iconNavBar-undo-disabled, .resetIcon{
    font-size: 24px;
    color: #222;
  }

  .iconNavBar-undo-disabled::before {
    filter: invert(0.8);
  }

  .navBarIcon {
    border: none;
    margin-left: 0px;
  }

  .Container2d3d {
    position: absolute;
    top: 112px;
    right: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 48px;
    padding: 0px 3px 1px 3px;
    border-radius: 4px;
    background-color: #fff;
  }

  .Cont2d,
  .Cont3d {
    position: relative;
    display: grid;
    place-items: center;
    width: 50px;
    height: 40px;
    color: #777;
    font-size: 16px;
    font-weight: 500;
  }

  .text2d,
  .text3d {
    font-family: "SegoeUI";
  }

  .cont2d3dActive {
    border-radius: 4px;
    background-color: var(--bgColor);
    color: #fff;
    font-weight: 600;
    width: 50px;
    height: 40px;
  }
 
  .tooltipContainer3DBtn {
    visibility: visible;
    width: 256px;
    background-color: var(--bgColor);
    color: #fff;
    position: absolute;
    z-index: 100;
    margin-left: -60px;
    padding: 10px 12px 8px 12px;
    border-radius: 4px;
  }

  .tooltip2DMobile{
    bottom: -94px;
    right: -8px;

  }

  .tooltip2DDesktop{
    bottom: -94px;
    right: 2px;

  }

  .tooltipContainer3DBtn {
    visibility: visible;
  }

  .tooltipContainer3DBtn::after {
    content: "";
    position: absolute;
    top: -14px;
    right: 8%;
    border-width: 7px;
    border-style: solid;
    border-color: transparent transparent var(--bgColor) transparent;
  }

  .tooltipText3d {
    font-size: 14px;
    color: #fff;
    font-weight: 100;
    line-height: 1.43;
    font-family: "SegoeUI";
  }

  .tooltipBtnCont {
    display: flex;
    justify-content: flex-end;
    gap: 32px;
  }

  .skipBtn,
  .nextBtn {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    font-family: "SegoeUI";
  }

  .nextBtn {
    font-weight: 600;
  }

  .sliderContainer {
    position: absolute;
    top: 216px;
    right: 0px;
  }

  .slider-demo-block {
    position: relative;
  }

  .layerParentContainer :deep() .el-slider__runway {
    width: 6px;
    background: #fff;
  }

  .layerParentContainer :deep() .el-slider__button {
    background-color: var(--bgColor);
    border: 3px solid #fff;
    margin-left: 2px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  }

.layerParentContainer>.rotSliderContainer :deep() .el-slider__button {
    background-color: transparent;
    margin-left: 2px;
    height: 34px;
    width: 34px;
    border:none
  }
  .layerParentContainer :deep() .el-slider__bar {
    background-color: var(--bgColor);
    width: 6px;
  }

  .containerMD {
    display: inherit;
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding: 16px;
    padding-bottom: 0px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    background-color: #fff;
  }

  .inputLabel {
    font-weight: 600;
    font-family: "SegoeUI";
    color:#777;
    font-size: 14px;
  }
  .inputLabel2 {
    font-size: 14px;
    font-weight: 600;
    font-family: "SegoeUI";
    color:#777;
    margin-top: 16px;
  } 

  .inputTag {
    height: 48px;
    width: 100%;
    font-size: 16px;
    color: #222;
    padding: 8px 16px;
    box-sizing: border-box;
    outline: none;
    border: 1px solid #999;
    border-radius: 4px;
    background-color: #fff;
    margin-bottom: 14px;
    font-family: "SegoeUI";
  }

  .drwBtnBtnMD {
    font-size: 16px;
    font-weight: 600;
    padding: 13px 17px;
    height: 48px;
    width: 100vw;
    border-radius: 0px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.08);
    margin-left: -16px;
    font-family: "SegoeUI";
    background-color: var(--bgColor);
  }

  .drwBtnBtnDV{
    font-size: 16px;
    font-weight: 600;
    height:40px;
    background-color: var(--bgColor);

  }

  .drwBtnBtnMD:hover, .drwBtnBtnDV:hover {
    background-color: var(--bgColor);
  }

  .drwBtnBtnMD.is-disabled, .drwBtnBtnMD.is-disabled:focus, .drwBtnBtnMD.is-disabled:hover, .drwBtnBtnDV.is-disabled, .drwBtnBtnDV.is-disabled:focus, .drwBtnBtnDV.is-disabled:hover {
    color: #ccc;
    background-image: linear-gradient(to bottom, #f5f7fa, #e8edf2);
    border: none;
    border-top: 1px solid #ccc;
  }

  .layerParentContainer :deep() .el-button > span {
    font-family: "SegoeUI";
  }

  .gifContainer {
    position: fixed;
    bottom: 16px;
    right: 12px;
    z-index: 2;
  }

  .topGifContainer {
    bottom: 58px;
  }

  .bulbCont {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
    background-color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    cursor: pointer;
  }

  .tooltipContainer {
    visibility: visible;
    width: 328px;
    background-color: #fff;
    position: absolute;
    z-index: 100;
    bottom: 52px;
    right: 0px;
    padding: 14px 16px 22px 16px;
    border-radius: 8px;
  }

  .tooltipContainer::after {
    content: "";
    position: absolute;
    bottom: -16px;
    right: 3%;
    border-width: 9px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
  }

  .bulbIcon:hover .tooltipContainer {
    visibility: visible;
  }

  .tooltipHeading {
    font-size: 16px;
    color: #777;
    font-weight: 600;
    margin-bottom: 8px;
    font-family: "SegoeUI";
  }

  .tooltipText {
    font-size: 16px;
    color: #222;
    line-height: 1.5;
    margin-bottom: 10px;
    font-family: "SegoeUI";
  }

  .gifImg {
    width: 296px;
    height: 250px;
    object-fit: cover;
  }

  .positionR {
    position: relative;
  }

  .commonBtn {
    position: absolute;
    top: 112px;
    right: 12px;
    font-family: "SegoeUI";
    border-radius: 0px;
    background-color: var(--bgColor);
    border-color: var(--bgColor);
    height: 48px;
    width: 104px;
    border-radius: 4px;
  }
  
  .commonBtn:hover {
    background-color: var(--bgColor);
  }

  .commonBtn.is-disabled, .commonBtn.is-disabled:focus, .commonBtn.is-disabled:hover {
    color: #ccc;
    background-image: linear-gradient(to bottom, #f5f7fa, #e8edf2);
    border: none;
    border-top: 1px solid #ccc;
  }

  .rotSliderContainer {
    position: absolute;
    bottom: 72px;
    width: 75vw;
    left: 24px;
    max-width: 260px;
  }

  .main {
  position: relative;
  }

#slider {
  -webkit-appearance: none; 
  width: 100%;
  height: 8px;
  border-radius: 4px;
}

/* Design slider button */
#slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: relative;
  z-index: 3;
}

#selector {
  width: 48px;
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-40%);
  z-index: 2;
}

#selectValue {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  position: absolute;
  bottom: 12px;
  background: var(--bgColor);
  text-align: center;
  line-height: 28px;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  border: 3px solid #fff;
}

.sliderTooltip {
  left: 40%;
  transform: translate(-50%, 0%);
  margin: 0px;
  position: absolute;
  bottom: 56px;
  visibility: visible;
  width: 256px;
  background-color: var(--bgColor);
  color: #fff;
  position: absolute;
  z-index: 100;
  padding: 10px 12px 8px 12px;
  border-radius: 4px;
}

.sliderTooltip::after {
    content: "";
    position: absolute;
    bottom: -14px;
    left: 50%;
    border-width: 7px;
    border-style: solid;
    transform: translate(-50%, 0%);
    border-color:var(--bgColor) transparent  transparent  transparent;
  }

  .sliderTooltipTwo {
  right: 48px;
  position: absolute;
  bottom: 8%;
  visibility: visible;
  width: 260px;
  background-color: var(--bgColor);
  color: #fff;
  position: absolute;
  z-index: 100;
  padding: 10px 12px 8px 12px;
  border-radius: 4px;
}

.sliderTooltipTwo::after {
    content: "";
    position: absolute;
    top: 50%;
    right: -5%;
    border-width: 7px;
    border-style: solid;
    transform: translate(0%, -50%);
    border-color:  transparent  transparent  transparent var(--bgColor);
  }

#progressBar {
  width: 50%;
  height: 8px;
  background: var(--bgColor);
  border-radius: 3px;
  position: absolute;
  bottom: 3px;
  left: 0;
}
.inputTag::placeholder{
  color:#777 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}
.info-container{
  padding-bottom: 16px;
  display: grid;
  row-gap: 16px;
}
.info-content{
  display:grid;
  row-gap: 8px;
}
.smLabel{
    font-size: 12px;
  }
  .mdLabel{
    font-size: 14px;
  }
  .ContainerSolaAccess{
    position: absolute;
    top: 128px;
    right: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0px 3px 1px 3px;
    border-radius: 4px;

  }

  .tooltipContainerSolarAccessBtn {
    visibility: visible;
    width: 256px;
    background-color: var(--bgColor);
    color: #fff;
    position: absolute;
    z-index: 100;
    right: -8px;
    margin-left: -60px;
    padding: 10px 12px 8px 12px;
    border-radius: 4px;
  }
 
  .change-bottom-solarAccess{
    bottom: -8px;
  }

  .change-bottom-irradiance{
    bottom: -64px;
  }
  
  .bottomPosition{
    top:60px;
  }
  .solarAccessRight{
    right:348px;
  }
.irradianceRight{
  right: 280px;
}

.layerParentContainer>.containerMD :deep() .el-slider__bar {
    width: 6px;
    background: #006eaf !important;
  }
  .layerParentContainer>.containerMD :deep() .el-slider__button {
  border: 3px solid var(--White, #fff);
  background: var(--Primary, #006eaf);
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
  height: 15px;
  width: 15px;
}
.layerParentContainer>.containerMD :deep() .el-slider__runway {
 background-color: #ccc !important;
 width: 6px;
}
  .tariff-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tariff-input{ 
    display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
  }
  .tariff-input-box {
  border-radius: 4px;
  border: 1px solid var(--999, #999);
  background: var(--White, #fff);
  width: 80px;
  padding: 5px;
  display: flex;
  align-items: center;
  height: 40px;
}
.time_input {
  outline: none;
  border: none;
  width: 30px;
}
.tariff-slider{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.tariff-range-max{
  width: 36px;
}
.tariff-range-min{
  width: auto;
}
.triff-inc-dec{
  display: flex;
  justify-content: center;
  align-items: center;
 border-radius: 50%;
 border: 1px solid #222;
 width:16px;
 height: 16px;
 background-color: #222;
 color: #fff;
 font-size: 14px;
 font-weight: 600;
}
.layerParentContainer>.containerMD :deep() .el-input-group__append {
  box-shadow: none;
  background-color: white;
  padding: 0;
}

.layerParentContainer>.containerMD :deep() .el-input__inner {
  color: black;
  background-color: white !important;
}

.layerParentContainer>.containerMD :deep() .el-input__wrapper {
  box-shadow: none;
  padding-left: 1px;
}
.layerParentContainer>.containerMD :deep() .el-input-group{
  border:1px solid #777;
  padding: 8px 16px;
  border-radius: 4px;

}
.layerParentContainer>.containerMD :deep() .el-input__inner::placeholder{
  color: #777 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}

.containerDV :deep() .el-input-group__append {
  box-shadow: none;
  background-color: white;
  padding: 0;
}

.containerDV :deep() .el-input__inner {
  color: black;
  background-color: white !important;
}

.containerDV :deep() .el-input__wrapper {
  box-shadow: none;
  padding-left: 1px;
}
.containerDV :deep() .el-input-group{
  border:1px solid #777;
  padding: 8px 16px;
  border-radius: 4px;

}
.containerDV :deep() .el-input__inner::placeholder{
  color: #777 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}




.custom-slider-tooltip {
  background-color: #3498db !important;  /* Change background color */
  color: white !important;              /* Change text color */
  border-radius: 8px !important;        /* Add rounded corners */
  font-weight: bold !important;         /* Make text bold */
  padding: 5px 10px !important;         /* Adjust padding */
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2) !important;
}
.layerParentContainer>.containerMD :deep() .el-radio__input.is-checked .el-radio__inner {
  border-color: #006eaf;
    background-color: #fff;
    border: 2px solid #006eaf;

}
.layerParentContainer>.containerMD :deep() .el-radio__inner::after {
  height: 7px;
  width: 7px;
  background-color: #006eaf;
  left: 50%;
  top: 50%;
}
.layerParentContainer :deep() .el-button.is-plain{
  background-color: none !important;

}
.layerParentContainer>.containerMD :deep() .el-radio__input.is-checked+.el-radio__label{
  color:#006eaf;
}
.warning{
  color:red;
  font-size: 12px;
}
.icon-container{
  background-color: #fff;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border:1px solid #ccc;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.selectedSolarAccess{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
    background-color:var(--bgColor);
    color: #fff;
    font-weight: 600;

}

.layerParentContainer :deep() .el-dialog__header {
  display: none;
}
.layerParentContainer :deep() .el-dialog {
border-radius: 8px;
}

.dialog-footer{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.btn-content{
  width:134px;
  height: 40px;
}
.btn-color{
  background-color: var(--bgColor);
}

.btn-content.is-disabled, .btn-content.is-disabled:focus, .btn-content.is-disabled:hover {
    color: #ccc;
    background-image: linear-gradient(to bottom, #f5f7fa, #e8edf2);
    border: none;
  }

  .commonBtnDV{
    height: 48px;
    width: 100%;
    padding:8px 16px;
    background-color: var(--bgColor);
    border-color: var(--bgColor);

  }

  .Container2d3dDV {
    position: absolute;
    top: 112px;
    right: 12px;
    height: 48px;
    padding: 0px 3px 1px 3px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    gap:16px;
  }
  .container2d3dbtns{
    background-color: #fff;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:8px 4px ;
    border-radius: 4px;
    cursor: pointer;
  }

  .ContainerSolarIrradiance{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap:16px;
    cursor: pointer;
  }

  .showOnOverlay{
    position: relative;
    z-index: 20;
  }
  .showOnOverlayMD{
    position: absolute;
    z-index: 20;
   
  }
  
  .slider-container {
  position: relative;
  width: 300px;
}

.custom-slider {
  width: 100%;
}

.custom-thumb {
  position: absolute;
  top: -4px;
  transform: translateX(-50%);
  background-color:var(--bgColor);
  color: white;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  border:3px solid #fff;
  font-size: 12px;
}
@media (max-width: 1100px) {
  .undoRedoContainerOuter,.backBtnContainer,.Container2d3d{
    top:68px;
  }

  .undoRedoContainerOuter{
    right:12px;
  }

  .commonBtn{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 48px;
    font-size: 18px;
    font-weight: 600;
    top:auto;
    right:0px;
  }

  .sliderContainer {
    top: 152px;
  }

}
</style>

